export default "__VITE_ASSET__CKDowsmt__"